define("shared/components/shared/credentials/grant-new-permissions", ["exports", "@ember/component", "@ember/template-factory", "@ember/service", "@glimmer/component", "ember-concurrency"], function (_exports, _component, _templateFactory, _service, _component2, _emberConcurrency) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;

  var _class, _descriptor, _descriptor2, _descriptor3;

  0; //eaimeta@70e063a35619d71f0,"ember-cli-htmlbars",0,"@ember/service",0,"@glimmer/component",0,"ember-concurrency"eaimeta@70e063a35619d71f

  function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }

  function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

  function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }

  function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'proposal-class-properties is enabled and runs after the decorators transform.'); }

  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    <Shared::Modal @closable={{false}} @close={{action @close}} as |modal|>
    <modal.card @closeIcon={{false}} @portrait={{true}}>
      <modal.card-header @title={{t "credentials.grant_permission.title"}} />
  
      <modal.card-body class="u--p__t__0">
  
        <img class="o--media" src="/assets/images/img--credentials--grantPermissions.png" />
  
        <ol class="u--p__l">
          <li>{{html-safe (t "credentials.grant_permission.step_1")}}</li>
          <li>{{html-safe (t "credentials.grant_permission.step_2" pageName=this.pageName)}}</li>
          <li>{{html-safe (t "credentials.grant_permission.step_3")}}</li>
          <li>{{html-safe (t "credentials.grant_permission.step_4")}}</li>
        </ol>
  
        <p>{{html-safe (t "credentials.grant_permission.important_message")}}</p>
  
      </modal.card-body>
  
      <modal.card-footer>
  
        <Shared::Ui::Button
          @additional="block"
          @promise={{task this.refreshBusinessAfterGrant}}
          @runningText={{t "credentials.grant_permission.connecting"}}
          @text={{t "credentials.grant_permission.connect_facebook_to_later"}}
          @variant="primary"
        />
  
      </modal.card-footer>
  
    </modal.card>
  </Shared::Modal>
  */
  {
    "id": "39TRRwrW",
    "block": "[[[8,[39,0],null,[[\"@closable\",\"@close\"],[false,[28,[37,1],[[30,0],[30,1]],null]]],[[\"default\"],[[[[1,\"\\n  \"],[8,[30,2,[\"card\"]],null,[[\"@closeIcon\",\"@portrait\"],[false,true]],[[\"default\"],[[[[1,\"\\n    \"],[8,[30,2,[\"card-header\"]],null,[[\"@title\"],[[28,[37,2],[\"credentials.grant_permission.title\"],null]]],null],[1,\"\\n\\n    \"],[8,[30,2,[\"card-body\"]],[[24,0,\"u--p__t__0\"]],null,[[\"default\"],[[[[1,\"\\n\\n      \"],[10,\"img\"],[14,0,\"o--media\"],[14,\"src\",\"/assets/images/img--credentials--grantPermissions.png\"],[12],[13],[1,\"\\n\\n      \"],[10,\"ol\"],[14,0,\"u--p__l\"],[12],[1,\"\\n        \"],[10,\"li\"],[12],[1,[28,[35,3],[[28,[37,2],[\"credentials.grant_permission.step_1\"],null]],null]],[13],[1,\"\\n        \"],[10,\"li\"],[12],[1,[28,[35,3],[[28,[37,2],[\"credentials.grant_permission.step_2\"],[[\"pageName\"],[[30,0,[\"pageName\"]]]]]],null]],[13],[1,\"\\n        \"],[10,\"li\"],[12],[1,[28,[35,3],[[28,[37,2],[\"credentials.grant_permission.step_3\"],null]],null]],[13],[1,\"\\n        \"],[10,\"li\"],[12],[1,[28,[35,3],[[28,[37,2],[\"credentials.grant_permission.step_4\"],null]],null]],[13],[1,\"\\n      \"],[13],[1,\"\\n\\n      \"],[10,2],[12],[1,[28,[35,3],[[28,[37,2],[\"credentials.grant_permission.important_message\"],null]],null]],[13],[1,\"\\n\\n    \"]],[]]]]],[1,\"\\n\\n    \"],[8,[30,2,[\"card-footer\"]],null,null,[[\"default\"],[[[[1,\"\\n\\n      \"],[8,[39,4],null,[[\"@additional\",\"@promise\",\"@runningText\",\"@text\",\"@variant\"],[\"block\",[28,[37,5],[[30,0,[\"refreshBusinessAfterGrant\"]]],null],[28,[37,2],[\"credentials.grant_permission.connecting\"],null],[28,[37,2],[\"credentials.grant_permission.connect_facebook_to_later\"],null],\"primary\"]],null],[1,\"\\n\\n    \"]],[]]]]],[1,\"\\n\\n  \"]],[]]]]],[1,\"\\n\"]],[2]]]]]],[\"@close\",\"modal\"],false,[\"shared/modal\",\"action\",\"t\",\"html-safe\",\"shared/ui/button\",\"task\"]]",
    "moduleName": "shared/components/shared/credentials/grant-new-permissions.hbs",
    "isStrictMode": false
  });

  let GrantNewPermissionsComponent = (_class = class GrantNewPermissionsComponent extends _component2.default {
    constructor() {
      super(...arguments);

      _initializerDefineProperty(this, "credentials", _descriptor, this);

      _initializerDefineProperty(this, "credentialStatus", _descriptor2, this);

      _initializerDefineProperty(this, "segment", _descriptor3, this);
    }

    get socialProfile() {
      return this.credentials.socialProfile;
    }

    get state() {
      return this.credentials.state;
    }

    get pageName() {
      return this.state.nameOfPage || this.state.activePage?.name;
    }

    *refreshBusinessAfterGrant() {
      const success = yield this.args.refreshBusiness.perform();

      if (success) {
        const fb_page_input = this.state.nameOfPage;
        const connected_page = this.state.activePage.name;
        this.segment.track('changed-page-on-instagram-creds-wiz', {
          social_profile: this.socialProfile,
          fb_page_input,
          connected_page,
          fb_page_connection_result: fb_page_input === connected_page ? 'match' : 'no match',
          page: this.credentials.source
        });
      } else {
        this.segment.track('canceled-change-page-on-instagram-creds-wiz', {
          social_profile: this.socialProfile,
          page: this.credentials.source
        });
      }

      this.credentialStatus.checkBrokenProfiles();
    }

  }, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "credentials", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "credentialStatus", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "segment", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _applyDecoratedDescriptor(_class.prototype, "refreshBusinessAfterGrant", [_emberConcurrency.task], Object.getOwnPropertyDescriptor(_class.prototype, "refreshBusinessAfterGrant"), _class.prototype)), _class);
  _exports.default = GrantNewPermissionsComponent;
  (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, GrantNewPermissionsComponent);
});